(function () {
  "use strict";

  var uiSelector = ".rehair-custom-flow-ui";
  // Only the native button owns the Omega click handler. Never rewrite its Vue wrapper.
  var quoteButtonSelector = "button.omgrfq-btn-quotes";
  var autoSubmitting = false;
  var appSubmitStarted = false;
  var fallbackTimer = null;

  function setNativeValue(field, value) {
    if (!field) return;
    var prototype = field.tagName === "TEXTAREA" ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(prototype, "value");
    if (descriptor && descriptor.set) descriptor.set.call(field, value);
    else field.value = value;
    field.dispatchEvent(new Event("input", { bubbles: true }));
    field.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function moveTrustAboveBuilder() {
    var ui = document.querySelector(uiSelector);
    if (!ui || !ui.parentNode) return;

    var price = document.querySelector(".main-product__block-custom_liquid");
    var reviews = document.querySelector(".main-product__block:has(.prorw-revi-badge)");
    if (price) price.classList.add("rehair-custom-trust-price");
    if (reviews) reviews.classList.add("rehair-custom-trust-review");

    if (price && reviews) {
      if (price.nextElementSibling !== reviews || reviews.nextElementSibling !== ui) {
        ui.parentNode.insertBefore(price, ui);
        ui.parentNode.insertBefore(reviews, ui);
      }
      return;
    }

    if (price && price.nextElementSibling !== ui) ui.parentNode.insertBefore(price, ui);
    if (reviews && reviews.nextElementSibling !== ui) ui.parentNode.insertBefore(reviews, ui);
  }

  function contactMarkup() {
    return (
      '<section class="rehair-custom-flow-contact" data-rehair-flow-contact>' +
        '<div class="rehair-custom-flow-contact__heading">' +
          '<div><p>FINAL STEP</p><h3>Where should we send your quote?</h3></div>' +
          '<span>No payment is taken</span>' +
        '</div>' +
        '<p class="rehair-custom-flow-contact__intro">Enter your contact details once. Your confirmed specifications will be attached automatically.</p>' +
        '<div class="rehair-custom-flow-contact__grid">' +
          '<label><span>Name <em>*</em></span><input type="text" autocomplete="name" data-rehair-contact-name required></label>' +
          '<label><span>Email <em>*</em></span><input type="email" autocomplete="email" data-rehair-contact-email required></label>' +
          '<label><span>Phone / WhatsApp</span><input type="tel" autocomplete="tel" placeholder="Include country code" data-rehair-contact-phone></label>' +
          '<label class="rehair-custom-flow-contact__message"><span>Anything else we should know?</span><textarea rows="3" data-rehair-contact-message placeholder="Optional notes for our specialist"></textarea></label>' +
        '</div>' +
        '<label class="rehair-custom-flow-contact__consent"><input type="checkbox" required data-rehair-contact-consent><span>I agree that ReHair may contact me about this quote request. <em>*</em></span></label>' +
        '<p class="rehair-custom-flow-contact__status" data-rehair-contact-status aria-live="polite"></p>' +
      '</section>'
    );
  }

  function ensureContactStep() {
    if (document.body.classList.contains("rehair-custom-quote-complete")) return;
    var ui = document.querySelector(uiSelector);
    var quoteSlot = ui && ui.querySelector("[data-flow-quote]");
    if (!quoteSlot) return;

    if (!quoteSlot.querySelector("[data-rehair-flow-contact]")) {
      quoteSlot.insertAdjacentHTML("afterbegin", contactMarkup());
    }

    quoteSlot.querySelectorAll(quoteButtonSelector).forEach(function (button) {
      if (!autoSubmitting && button.textContent.trim() !== "Submit quote request") {
        button.textContent = "Submit quote request";
      }
    });
  }

  function contactFields() {
    var root = document.querySelector("[data-rehair-flow-contact]");
    return {
      root: root,
      name: root && root.querySelector("[data-rehair-contact-name]"),
      email: root && root.querySelector("[data-rehair-contact-email]"),
      phone: root && root.querySelector("[data-rehair-contact-phone]"),
      message: root && root.querySelector("[data-rehair-contact-message]"),
      consent: root && root.querySelector("[data-rehair-contact-consent]"),
      status: root && root.querySelector("[data-rehair-contact-status]"),
    };
  }

  function validateContact() {
    var fields = contactFields();
    if (!fields.root) return false;
    var required = [fields.name, fields.email, fields.consent];
    for (var index = 0; index < required.length; index += 1) {
      if (!required[index].checkValidity()) {
        required[index].reportValidity();
        required[index].focus();
        return false;
      }
    }
    return true;
  }

  function setInlineStatus(message, error) {
    var fields = contactFields();
    if (!fields.status) return;
    fields.status.textContent = message || "";
    fields.status.setAttribute("data-error", error ? "true" : "false");
  }

  function configurationMessage() {
    var fields = contactFields();
    var notes = fields.message && fields.message.value.trim();
    // Specifications belong to product properties, not the customer's message.
    return notes || "";
  }

  function fillQuoteSnapAndSubmit() {
    if (!autoSubmitting || appSubmitStarted) return;
    var popup = document.querySelector(".omgrfq-popup-snap");
    var list = popup && popup.querySelector(".omgrfq-quote-list");
    if (!list) return;

    var fields = contactFields();
    var name = list.querySelector('[name="omgrfq-form_0"]');
    var phone = list.querySelector('[name="omgrfq-form_1"]');
    var email = list.querySelector('[name="omgrfq-form_2"]');
    var message = list.querySelector('[name="omgrfq-form_3"]');
    var submit = Array.prototype.slice.call(list.querySelectorAll("button")).filter(function (button) {
      return /submit request/i.test(button.textContent || "");
    })[0];
    if (!name || !email || !message || !submit) return;

    setNativeValue(name, fields.name.value.trim());
    setNativeValue(phone, fields.phone.value.trim());
    setNativeValue(email, fields.email.value.trim());
    setNativeValue(message, configurationMessage());
    appSubmitStarted = true;
    submit.click();
  }

  function showSuccess() {
    window.clearTimeout(fallbackTimer);
    autoSubmitting = false;
    appSubmitStarted = false;
    document.body.classList.remove("rehair-custom-quote-auto-submit");
    document.body.classList.add("rehair-custom-quote-complete");

    var overlay = document.querySelector(".omgrfq-overlay");
    if (overlay) overlay.style.display = "none";
    var ui = document.querySelector(uiSelector);
    var quoteSlot = ui && ui.querySelector("[data-flow-quote]");
    if (!quoteSlot) return;
    quoteSlot.innerHTML =
      '<section class="rehair-custom-quote-success" role="status" tabindex="-1">' +
        '<span aria-hidden="true">✓</span>' +
        '<p>QUOTE REQUEST RECEIVED</p>' +
        '<h3>Thank you — your request is with our specialists.</h3>' +
        '<div>We will review your specifications and contact you within 1–2 business days. No payment has been taken.</div>' +
        '<nav><a href="/collections/mens-hairpieces">Continue shopping</a><a href="https://wa.me/19176056228">Ask us on WhatsApp</a></nav>' +
      '</section>';
    var title = ui.querySelector("[data-flow-title]");
    if (title) title.textContent = "Quote request received";
    maintainSuccessState();
    quoteSlot.querySelector(".rehair-custom-quote-success").focus();
  }

  function maintainSuccessState() {
    if (!document.body.classList.contains("rehair-custom-quote-complete")) return;
    var ui = document.querySelector(uiSelector);
    if (!ui) return;
    var title = ui.querySelector("[data-flow-title]");
    var back = ui.querySelector("[data-flow-back]");
    var next = ui.querySelector("[data-flow-next]");
    if (title && title.textContent.trim() !== "Quote request received") {
      title.textContent = "Quote request received";
    }
    if (back) back.hidden = true;
    if (next) next.hidden = true;
  }

  function quoteSnapSucceeded() {
    var list = document.querySelector(".omgrfq-quote-list");
    if (!list) return false;
    var text = (list.textContent || "").replace(/\s+/g, " ");
    return /continue shopping/i.test(text) && !/contact info|submit request/i.test(text);
  }

  function startAutomaticSubmission(button) {
    if (autoSubmitting) return false;
    if (window.rehairValidateQuoteChoices && !window.rehairValidateQuoteChoices()) return false;
    if (!validateContact()) return false;
    autoSubmitting = true;
    appSubmitStarted = false;
    document.body.classList.add("rehair-custom-quote-auto-submit");
    window.setTimeout(function () {
      if (autoSubmitting) button.textContent = "Sending request…";
    }, 0);
    setInlineStatus("Sending your specifications securely…", false);

    var attempts = 0;
    var handoffTimer = window.setInterval(function () {
      attempts += 1;
      fillQuoteSnapAndSubmit();
      if (appSubmitStarted || attempts > 50) window.clearInterval(handoffTimer);
    }, 120);

    fallbackTimer = window.setTimeout(function () {
      if (!autoSubmitting || quoteSnapSucceeded()) return;
      var appSubmitWasStarted = appSubmitStarted;
      autoSubmitting = false;
      appSubmitStarted = false;
      document.body.classList.remove("rehair-custom-quote-auto-submit");
      button.textContent = "Submit quote request";
      setInlineStatus(appSubmitWasStarted ? "We could not confirm receipt yet. Please do not submit again; contact us to check your request." : "Your request has not been sent. Please check the contact form if it is visible, or contact us for help. Your details are still on this page.", true);
    }, 12000);
    return true;
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest(quoteButtonSelector);
    if (!button || !button.closest("[data-flow-quote]")) return;
    if (!startAutomaticSubmission(button)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  var observer = new MutationObserver(function () {
    moveTrustAboveBuilder();
    ensureContactStep();
    maintainSuccessState();
    if (autoSubmitting) {
      fillQuoteSnapAndSubmit();
      if (quoteSnapSucceeded()) showSuccess();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  moveTrustAboveBuilder();
  ensureContactStep();
  window.setTimeout(moveTrustAboveBuilder, 1800);
  window.setTimeout(ensureContactStep, 2200);
})();
